export const uuidV4 = (): string => {
  if (crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // @ts-expect-error - Operator '+' in fact can be applied to types 'number[]' and 'number'
  // But I don't know why, this works and that's all I need
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
};
